isPlanSelectionPlans